// An owner's or officer's standing in the business (PMS-S704): a closed list,
// beside the person's free-text job title, which also holds plain job titles
// ("CFO") and so can never be an enum. PMS took Pie's OfficerTitles as the
// carrier-neutral start. One list for every surface that shows or edits it.

export const OFFICER_TITLES = [
  "sole_proprietor",
  "partner",
  "corporate_officer",
  "board_of_directors",
  "founder",
  "voting_member",
  "other",
] as const;

export type OfficerTitle = (typeof OFFICER_TITLES)[number];

export const OFFICER_TITLE_LABELS: Record<OfficerTitle, string> = {
  sole_proprietor: "Sole proprietor",
  partner: "Partner",
  corporate_officer: "Corporate officer",
  board_of_directors: "Board of directors",
  founder: "Founder",
  voting_member: "Voting member",
  other: "Other",
};

export const OFFICER_TITLE_OPTIONS = OFFICER_TITLES.map((value) => ({
  value,
  label: OFFICER_TITLE_LABELS[value],
}));

/** The value as a title, if it is one: a read narrowed from what arrived. */
export function asOfficerTitle(value: unknown): OfficerTitle | null {
  return OFFICER_TITLES.find((t) => t === value) ?? null;
}
